<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="card mt-1">
                <div class="card-body p-4">
                    <div class="d-flex mb-4 mt-1 justify-content-between">
                        <div class="file-upload">
                            <div class="row">
                                <div class="col-xl-6 col-lg-6 col-sm-12 col-md-12 pt-5 position-relative">
                                    <div class="upload-container">
                                        <div class="upload-icon mx-3">
                                            <span class="fa fa-cloud-upload fa-5x"></span>
                                        </div>
                                        <div class="upload-title mx-3">
                                            <p>
                                                {{ prFiles[0]?.file?.name || "Drag and drop the EXCEL file to upload"}}
                                            </p>
                                        </div>
                                        <input type="file" #inputFile id="choose" (change)="verifyFile($event)" />
                                    </div>
                                    <div class="text-center my-3">
                                        <a class="btn btn-outline-primary btn-lg" (click)="inputFile.click()">
                                            Choose File
                                        </a>
                                    </div>
                                    <div class="upload-instructions my-5 text-start">
                                        <h6>Upload Instructions: </h6>
                                        <ul>
                                            <li class='font-small'>
                                                1. Only EXCEL file format is supported
                                            </li>
                                            <li class='font-small'>
                                                2. During file upload, total size of the file must not exceed 20MB
                                            </li>
                                            <li class='font-small'>
                                                3. Only one file can be uploaded at a time
                                            </li>
                                        </ul>
                                        <div>
                                            <a class="text-small text-decoration-none cursor-pointer"
                                            download="CATALOGUE_AND_RATE_CONTRACT_TEMPLATE.xlsx" href="assets/templates/Latest_RC_Template.xlsx">
                                                <span class="fa fa-download pe-2"></span>
                                                <span>Download template file for Rate Contract upload</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="divider"></div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-sm-12 col-md-12 pt-5">
                                    <div class="px-4 py-1">
                                        <div class="text-start">
                                            <h6 class="fs-6">File Status</h6>
                                            <p class="text-muted my-3" *ngIf="!prFiles?.length">
                                                Please select Excel file to be uploaded.
                                            </p>
                                            <p className="text-muted my-3" *ngIf="prFiles?.length">
                                                File to be uploaded ({{prFiles?.length}} file,
                                                {{prFiles[0]?.formatSize}}).
                                            </p>
                                        </div>
                                        <div class="my-4 upload-view" *ngIf="prFiles?.length">
                                            <div>
                                                <p class='mb-1'>
                                                    {{prFiles[0]?.file?.name}}
                                                </p>
                                                <p class="mb-0 font-small">
                                                    {{prFiles[0]?.formatSize}}
                                                </p>
                                            </div>
                                            <div class='align-self-center'>
                                                <a class='text-primary pointer' (click)="clearFile()">
                                                    <span class="fa fa-trash fa-2x"></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <a class="btn btn-outline-primary mx-2" (click)="onUploadFile()">Upload RC</a>
    </div>
</section>